import React, { Fragment, useContext, useEffect, useState } from "react";
/// React router dom
import { Link, useParams } from "react-router-dom";
import { ThemeContext } from "../../../context/ThemeContext";
import defaultLogo from "../../../assets/images/cricket-logo.png";
import logo1 from "../../../assets/images/whitefield-logo.png";
import { getPublicTenantDetails, getPublicTenantLogoByFilename } from "../../../services/publicService";

export function NavMenuToggle() {
  setTimeout(() => {
    let mainwrapper = document.querySelector("#main-wrapper");
    if (mainwrapper.classList.contains("menu-toggle")) {
      mainwrapper.classList.remove("menu-toggle");
    } else {
      mainwrapper.classList.add("menu-toggle");
    }
  }, 200);
}

const PublicNavHader = () => {
  const { id } = useParams();
  const { navigationHader, openMenuToggle, background } =
    useContext(ThemeContext);
  const [tenantData, setTenantData] = useState(null);
  const [logo, setLogo] = useState(null);

  async function fecthTenant(tenantId) {
    try {
      const res = await getPublicTenantDetails(tenantId);
      if (res) {
        setTenantData(res);
      }
    } catch (error) {
      console.error("Failed to fetch tenant details:", error);
    }
  }

  async function fecthTenantLogo(fileName) {
    if (!fileName) return;
    try {
      const res = await getPublicTenantLogoByFilename(fileName);
      if (res) {
        setLogo(res);
      }
    } catch (error) {
      console.error("Failed to fetch tenant logo:", error);
    }
  }

  useEffect(() => {
    if (id) {
      fecthTenant(id);
    }
  }, [id]);

  useEffect(() => {
    if (tenantData?.logo?.fileName) {
      fecthTenantLogo(tenantData.logo.fileName);
    }
  }, [tenantData]);

  // Determine logo source with reliable fallback to defaultLogo
  const logoSrc =
    (typeof logo === "string" ? logo : logo?.fileUrl || logo?.url) ||
    (typeof tenantData?.logo === "string"
      ? tenantData.logo
      : tenantData?.logo?.fileUrl || tenantData?.logo?.url) ||
    defaultLogo;

  return (
    <div className="nav-header">
      <Link to="/dashboard" className="brand-logo">
        {background.value === "dark" || navigationHader !== "color_1" ? (
          <Fragment>
            <img
              className="logo-abbr"
              src={logoSrc}
              onError={(e) => {
                e.currentTarget.src = defaultLogo;
              }}
              alt="Logo Abbr"
            />
            <h2
              className="brand-title"
              style={{
                // fontFamily: "'Poppins', sans-serif",
                fontWeight: 800,
                letterSpacing: "1px",
                color: "#fff",
              }}
            >
              CrickPay
            </h2>
          </Fragment>
        ) : (
          <Fragment>
            <img
              className="logo-abbr"
              src={logoSrc}
              onError={(e) => {
                e.currentTarget.src = defaultLogo;
              }}
              alt="Logo Abbr"
            />
            <h2
              className="brand-title"
              style={{
                // fontFamily: "'Poppins', sans-serif",
                fontWeight: 800,
                letterSpacing: "1px",
                color: "#fff",
              }}
            >
              CrickPay
            </h2>
          </Fragment>
        )}
      </Link>
    </div>
  );
};

export default PublicNavHader;
